var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('p',[_vm._v("Please logout using this button to safely exit the game to save your progress.")]),_c('button',{staticClass:"button is-danger is-big",on:{"click":_vm.logout}},[_vm._v("Logout")])])}
var staticRenderFns = []

export { render, staticRenderFns }